<script setup>

import MultiSearchDropDown from '@/components/common/input/MultiSearchDropDown';
import StaticTooltip from "@/components/common/other/StaticTooltip";
import {useStore} from "vuex";

const emits = defineEmits(['select', 'clear', 'input', 'clear-fields']);
const store = useStore();
const props = defineProps({

  modelValue: {},
  disableFields: false,
  allowCustomValue: {type: Boolean, default: true},
  isModalAddress: {type: Boolean, default: true},
  readOnly: {type: Boolean, default: false},
  currentTile: '',
  requiredFields: {type: Array, default: function () {
      return []
    }},

})

function getRequiredField(field) {

  return props.requiredFields.filter(x => x.modelName === field)[0]?.validate

}

</script>


<template>
  <div class="global-css_vertical-form-layout" style="padding-top: 20px">
    <div class="global-flex-layout">
      <TextInput
          v-model="props.modelValue.companyName"
          :requiredField="getRequiredField('companyName')"
          v-model:validation-fail="props.requiredFields.find(x => x.modelName === 'companyName').trigger"
          :maxLength="50"
          :width="320"
          :disable="props.disableFields"
          :label-width="100"
          label="Name">
      </TextInput>
      <StaticTooltip v-if="props.isModalAddress">
        <template #content>
          Clear All Fields
        </template>
        <i class="fa-solid fa-trash-can-list" @click="emits('clear-fields')"></i>
      </StaticTooltip>
    </div>
    <TextInput
        v-model="props.modelValue.addressLine1"
        :requiredField="getRequiredField('addressLine1')"
        v-model:validation-fail="props.requiredFields.find(x => x.modelName === 'addressLine1').trigger"
        :maxLength="50"
        :width="320"
        :disable="props.disableFields"
        :label-width="100"
        label="Address Line 1">
    </TextInput>
    <TextInput
        v-model="props.modelValue.addressLine2"
        :requiredField="getRequiredField('addressLine2')"
        v-model:validation-fail="props.requiredFields.find(x => x.modelName === 'addressLine2').trigger"
        :maxLength="50"
        :disable="props.disableFields"
        :width="320"
        :label-width="100"
        label="Address Line 2">
    </TextInput>
    <TextInput
        v-model="props.modelValue.city"
        :requiredField="getRequiredField('city')"
        v-model:validation-fail="props.requiredFields.find(x => x.modelName === 'city').trigger"
        :maxLength="50"
        :disable="props.disableFields"
        :width="320"
        :label-width="100"
        label="City">
    </TextInput>
    <TextInput
        v-model="props.modelValue.postCode"
        :requiredField="getRequiredField('postCode')"
        v-model:validation-fail="props.requiredFields.find(x => x.modelName === 'postCode').trigger"
        :maxLength="50"
        :disable="props.disableFields"
        :width="320"
        :label-width="100"
        label="Post Code">
    </TextInput>
    <TextInput
        v-model="props.modelValue.county"
        :requiredField="getRequiredField('county')"
        v-model:validation-fail="props.requiredFields.find(x => x.modelName === 'county').trigger"
        :maxLength="50"
        :disable="props.disableFields"
        :width="320"
        :label-width="100"
        label="County">
    </TextInput>
    <MultiSearchDropDown
         v-model="props.modelValue.country"
         :requiredField="getRequiredField('country')"
         v-model:validation-fail="props.requiredFields.find(x => x.modelName === 'country').trigger"
        :width="320"
        :label-width="100"
        :allowCustomValue="false"
        placeholder="Select or Search...."
        label="Country"
        :dataSource="store.state.dataSource"
        :selectPrimitiveValue="true">
    </MultiSearchDropDown>

  </div>
</template>

<style scoped>

</style>
